import { Routes } from '@angular/router';

import { AcknowledgeComponent } from './acknowledge/acknowledge.component';
import { RootComponent } from '../login/root/root.component';
import { NotificationProcessComponent } from './notification-process/notification-process.component';


export const routing: Routes = [
  {
    path: 'weblink',
    component:  RootComponent,

    children: [
      { path: 'acknowledge/:ackHash', component: AcknowledgeComponent },
      { path: 'notificationProcess', component: NotificationProcessComponent },
    ]
  }
];
